import { styled } from "@mui/system";
import { TableRow, TableCell } from "@mui/material";

export const StyledTableCell = styled(TableCell)((props) => ({
    "&.MuiTableCell-head": {
        fontFamily: "Unilever Shilling",
        backgroundColor: "var(--primany-table-header-color)",
        color: "#fff",
        textAlign: "center",
        padding: "2px",
        fontSize: "11px",
        fontWeight: 600,
        outline: "1px solid #EAECF0",
        whiteSpace: "nowrap",
    },
    "&.MuiTableCell-body": {
        fontFamily: "Unilever Shilling",
        fontSize: "11px",
        fontWeight: 400,
        padding: "1px",
        color: "#2B2B2B",
        border: "1px solid #EAECF0 !important",
        textAlign: "center",
        whiteSpace: "nowrap",
        // height: "30px"
    },
    "&.MuiTableCell-footer": {
        fontFamily: "Unilever Shilling",
        fontSize: "11px",
        fontWeight: 600,
        padding: "2px",
        color: "#2B2B2B",
        border: "1px solid #DBDBDB !important",
        textAlign: "center",
        whiteSpace: "nowrap",
        backgroundColor: "#ebedfa",
        outline: "1px solid #DBDBDB !important",

    }
}));

export const StyledTotalCell = styled(TableCell)((props) => ({
    "&.MuiTableCell-body": {
        fontFamily: "Unilever Shilling",
        fontSize: "11px",
        fontWeight: 600,
        padding: "1px",
        color: "#2B2B2B",
        border: "1px solid #DBDBDB !important",
        textAlign: "center",
        whiteSpace: "nowrap",
        backgroundColor: "#ebedfa",
        // height: "30px"
    },
}))

export const StyledTableRow = styled(TableRow)({
    backgroundColor: "#FFFFFF !important"
});

export const StyledFooterRow = styled(TableRow)({
    border: "1px solid #DBDBDB !important",
    // backgroundColor: "#FFFFFF !important"
})

